import { theme } from "@op-str/op-component-library"
import styled from "styled-components"
import { PageContent } from "./PageContent"

export const NarrowPageContent = styled(PageContent)`
  width: ${theme.ui.content.widthNarrow};
`
